import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { servicesData } from "../data/services.jsx";

function RedesignedServices() {
    const sectionRef = useScrollAnimation();

    return (
        <section ref={sectionRef} className="redesign-services" style={{backgroundImage: 'url(/assets/img/EIE-Schema.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center'}}>
            <div className="redesign-services-container">
                <div className="redesign-section-header scroll-animate-fade">
                    <div className="redesign-section-label"> PATENT PENDING</div>
                    <h2 className="redesign-section-title">Putting People at the Center</h2>
                    <p className="redesign-section-description">
                        <strong>EIE generates real-time emotional digital twins and graph neural networks of content.</strong> Why? Because <strong>emotions distinguish humans from machines</strong>—and we put people at the center.
                    </p>
                </div>
                <div className="redesign-services-grid">
                    {servicesData.map((service) => (
                        <div key={service.id} className="redesign-service-card scroll-animate">
                            <div className="redesign-service-icon">{service.icon}</div>
                            <h3 className="redesign-service-title">{service.title}</h3>
                            <p className="redesign-service-description">{service.description}</p>
                            <ul className="redesign-service-outcomes">
                                {service.outcomes.map((outcome, i) => (
                                    <li key={i}>{outcome}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default RedesignedServices;
